import React from "react"
import { ApolloError } from "apollo-client"

import { Paragraph, Link } from "components/text"

import { baseRoutes } from "routes"
import { getDisplayedErrorMessage, EMAIL_EXISTS_MESSAGE } from "./errorsFromException"

export function GraphQLError({ error }: { error?: ApolloError }) {
  const errorMessage = getDisplayedErrorMessage(error)

  return (
    <>
      <Paragraph color="salmon">{errorMessage}</Paragraph>
      {errorMessage === EMAIL_EXISTS_MESSAGE && (
        <Paragraph>
          <Link to={baseRoutes.signIn()}>Please click here to sign in.</Link>
        </Paragraph>
      )}
    </>
  )
}
